import { render, staticRenderFns } from "./UiDetailDisplay.vue?vue&type=template&id=19055966&"
import script from "./UiDetailDisplay.vue?vue&type=script&lang=js&"
export * from "./UiDetailDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports